import { AnimatePresence, motion } from "framer-motion";
import { Menu, X, ChevronDown } from "lucide-react";
import { useState } from "react";
import { Link } from "@/lib/router-compat";
import { HashLink } from "@/components/HashLink";
import logoWhiteAsset from "@/assets/OP2P-CRM-e-Agentes-de-IA-logotipo-branco-2026.webp.asset.json";
import { PRODUCTS } from "@/lib/products";

const navLinks = [
  { name: "Como funciona", href: "/#como-funciona" },
  { name: "Agentes inteligentes", href: "/#solucoes" },
  { name: "Migre seu CRM", href: "/#migre" },
  { name: "Funcionalidades", href: "/#funcionalidades" },
  { name: "Integrações", href: "/integracoes" },
];

export function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [solOpen, setSolOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-[60] bg-[hsl(220_20%_8%)] border-b border-white/10 shadow-[0_2px_20px_rgba(0,0,0,0.15)]">
      <div className="max-w-[1680px] mx-auto px-4 sm:px-6 min-h-[88px] md:min-h-[94px] flex items-center justify-start gap-4">
        <a href="/" className="flex items-center gap-2 py-[15px]">
          <img src={logoWhiteAsset.url} alt="OP2P ⊶ CRM e Agentes de IA" className="h-[46px] md:h-[52px] w-auto" />
        </a>

        <nav className="hidden lg:flex items-center gap-8 ml-auto">
          <div
            className="relative"
            onMouseEnter={() => setSolOpen(true)}
            onMouseLeave={() => setSolOpen(false)}
          >
            <button className="flex items-center gap-1 text-sm font-medium text-white/80 hover:text-white transition-colors">
              Soluções <ChevronDown className="w-3.5 h-3.5" />
            </button>
            <AnimatePresence>
              {solOpen && (
                <motion.div
                  initial={{ opacity: 0, y: 6 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 6 }}
                  transition={{ duration: 0.15 }}
                  className="absolute top-full left-1/2 -translate-x-1/2 pt-3 w-[720px]"
                >
                  <div className="bg-white rounded-2xl shadow-apple-xl border border-gray-100 p-3 grid grid-cols-2 gap-2">
                    {PRODUCTS.map((p) => (
                      <Link
                        key={p.slug}
                        to={`/${p.slug}`}
                        className="group flex gap-3 items-center p-3 rounded-xl hover:bg-gray-50 transition-colors"
                      >
                        <img src={p.image} alt={`${p.name} — OP2P CRM e Agentes de IA`} className="w-14 h-14 rounded-lg object-cover flex-shrink-0" loading="lazy" />
                        <div className="min-w-0">
                          <p className="text-sm font-bold text-gray-900 truncate">{p.name}</p>
                          <p className="text-xs text-gray-500 truncate">{p.short}</p>
                        </div>
                      </Link>
                    ))}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>

          {navLinks.map((l) => (
            <HashLink
              key={l.name}
              to={l.href}
              className="text-sm font-medium text-white/80 hover:text-white transition-colors"
            >
              {l.name}
            </HashLink>
          ))}
        </nav>

        <div className="flex items-center gap-2 ml-auto lg:ml-0">
          <button
            className="lg:hidden w-9 h-9 rounded-full bg-white/10 border border-white/15 flex items-center justify-center text-white"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            {menuOpen ? <X size={16} /> : <Menu size={16} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {menuOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="lg:hidden overflow-hidden bg-[hsl(220_20%_10%)] border-t border-white/5"
          >
            <div className="max-w-[1680px] mx-auto px-4 sm:px-6 py-4 flex flex-col gap-1">
              <p className="text-[10px] uppercase tracking-wider text-white/40 font-bold mt-1 mb-1">Soluções</p>
              {PRODUCTS.map((p) => (
                <Link
                  key={p.slug}
                  to={`/${p.slug}`}
                  onClick={() => setMenuOpen(false)}
                  className="text-sm text-white/80 hover:text-white py-1.5"
                >
                  {p.name}
                </Link>
              ))}
              <p className="text-[10px] uppercase tracking-wider text-white/40 font-bold mt-3 mb-1">Navegação</p>
              {navLinks.map((l) => (
                <HashLink
                  key={l.name}
                  to={l.href}
                  onClick={() => setMenuOpen(false)}
                  className="text-sm text-white/80 hover:text-white py-1.5"
                >
                  {l.name}
                </HashLink>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
